import { AbstractRecorder } from './AbstractRecorder';
import { WebEvaluator, loadWebEvaluator } from '../WebEvaluator';
export class WebEvaluatorRecorder extends AbstractRecorder {
    constructor(option) {
        super(option);
    }
    async destroy() {
        var _a;
        await super.destroy();
        (_a = this.we) === null || _a === void 0 ? void 0 : _a.delete();
    }
    workerName() {
        return 'WebEvaluator';
    }
    postMessageInit() {
        var _a;
        (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage({
            cmd: 'init',
            data: {
                srcSampleRate: this.option.sampleRate,
                mp3BitRate: this.option.sampleRate,
                erc: this.erc,
                batch: this.option.batch,
            }
        });
    }
    onMessage(event) {
    }
    /**
     * 获取erc信息
     */
    async getErc() {
        if (this.ercInfo) {
            return this.ercInfo;
        }
        await loadWebEvaluator();
        this.we = new WebEvaluator({ srcSampleRate: this.option.sampleRate });
        return this.ercInfo = await this.we.loadErc(this.erc);
    }
}
